<template>
  <span v-if="node.state !== 'normal'" class="bz-remap-wrap"
    @mouseenter="open = true" @mouseleave="open = false">
    <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-warn);">warning_amber</i>
    <span v-if="open" class="bz-remap-tip">{{ node.msg || 'This code changed in the 2022 NAICS revision.' }}</span>
  </span>
</template>

<script>
// 2022 NAICS remap warning — shows the API's selector_message verbatim.
export default {
  name: 'remap-flag',
  props: { node: { type: Object, required: true } },
  data() {
    return { open: false };
  },
};
</script>
